/** What a bulk import offers to add, and the detail its notice mentions. */
export interface BulkSelection {
  keys: string[];
  note: string;
}

/** ISINs as pasted from a sheet or typed: any whitespace, comma or semicolon. */
export function parseIsins(text: string): string[] {
  const isins = text
    .split(/[\s,;]+/)
    .map((isin) => isin.trim().toUpperCase())
    .filter(Boolean);
  return [...new Set(isins)];
}

/**
 * The entity keys of a portfolio exported from Cockpit (`{ name, content }`),
 * or null when the text is not such an export.
 */
export function parsePortfolioFile(text: string): string[] | null {
  try {
    const content = JSON.parse(text)?.content;
    if (!Array.isArray(content)) return null;
    const keys = content.filter(
      (key) => typeof key === 'string' && key.includes(':'),
    );
    return keys.length ? [...new Set<string>(keys)] : null;
  } catch {
    return null;
  }
}

export const countLabel = (count: number): string =>
  count === 1 ? '1 entity' : count + ' entities';
